import { render, staticRenderFns } from "./ChartsType2.vue?vue&type=template&id=33923a16&scoped=true"
import script from "./ChartsType2.vue?vue&type=script&lang=js"
export * from "./ChartsType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33923a16",
  null
  
)

export default component.exports